import { getRepaymentHistoryData } from '../../api/api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'

// action types
export const REQUEST_REPAYMENT_HISTORY =
  'rp/repayment/REQUEST_REPAYMENT_HISTORY'
export const RECEIVE_REPAYMENT_HISTORY =
  'rp/repayment/RECEIVE_REPAYMENT_HISTORY'

// action creators

export const requestRepaymentHistory = payload => ({
  type: REQUEST_REPAYMENT_HISTORY,
  payload,
})
// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_REPAYMENT_HISTORY:
      return {
        ...state,
        ...payload.payments.reduce(
          (obj, payment) => ({
            ...obj,
            [payment.id]: payment,
          }),
          {},
        ),
      }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// sagas

function* getRepaymentHistory({ payload }) {
  const { payments } = yield call(getRepaymentHistoryData, { id: payload.id })

  if (payments.length) {
    yield put({
      type: RECEIVE_REPAYMENT_HISTORY,
      payload: {
        planId: payload.id,
        payments,
      },
    })
  }
}

function* watchRequestRepaymentHistory() {
  yield takeLatest(
    REQUEST_REPAYMENT_HISTORY,
    createRequestSaga(getRepaymentHistory, {
      key: 'payments',
      message: __('Looking up repayment history'),
    }),
  )
}

export const sagas = [watchRequestRepaymentHistory]
